export default __webpack_public_path__ + "adfda37819bd6349d12eed00652b7f46.png";